(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cro-sticky-cta"] && !Shopify.designMode) return;
  try {
    (function () {
    var bar = document.getElementById('cro-sticky-cta');
    var mainBtn = document.querySelector('[name="add"], .product-form__submit');
    if (!bar || !mainBtn) return;

    var io = new IntersectionObserver(function (entries) {
      var visible = !entries[0].isIntersecting;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', String(!visible));
    }, { threshold: 0 });
    io.observe(mainBtn);

    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cro-sticky-atc]');
      if (!btn || btn.disabled) return;
      var id = btn.dataset.variantId;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      fetch(window.Shopify ? '/cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
